import { render, staticRenderFns } from "./ImportImages.vue?vue&type=template&id=54ed98f8&"
import script from "./ImportImages.vue?vue&type=script&lang=js&"
export * from "./ImportImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports